import SlaIndicator from "./slaIndicator.component";

export default SlaIndicator;
